import React from "react";
import styled from "styled-components";
import { z } from "zod";
import { Blade } from "../../../components/Blade";
import { mixinSkins } from "../../../skins/shared/mixins/themeStyles";
import { SkinId } from "../../../skins/types";
import { riotProductSkin } from "../skins/riot-product";
import { BladeContent } from "../../../components/BladeContent";
import { Media } from "../../../components/Media";
import { ContentItemBladeSchema } from "../../../schemas/blades/ContentItem";
import { AspectRatio } from "../../../components/AspectRatio";
import { ArticleCoveredCard } from "../../../molecules/ArticleCoveredCard";
export const ArticleMediaEmbedContractSchema = ContentItemBladeSchema.extend({
    type: z.literal("articleMediaEmbed"),
});
const _ArticleMediaEmbed = ({ className, content, ...props }) => {
    const { media, action } = content;
    const aspectRatio = media.dimensions ? media.dimensions.width / media.dimensions.height : 16 / 9;
    return (React.createElement(Blade, { "data-testid": "ArticleMediaEmbed", className: className, ...props },
        React.createElement(BladeContent, { width: "medium" }, action ? (React.createElement(ArticleCoveredCard, { content: content, ...props })) : (React.createElement(AspectRatio, { ratio: aspectRatio, "data-testid": "mediaAspectRatio" },
            React.createElement(Media, { media: media, autoPlay: false, controls: true }))))));
};
export const ArticleMediaEmbed = styled(_ArticleMediaEmbed) `
  ${mixinSkins({
    [SkinId.RiotProduct]: riotProductSkin,
})}
`;
//# sourceMappingURL=ArticleMediaEmbed.js.map